import { styled } from "@mui/material/styles";
import { Drawer, Stack } from "@mui/material";

export const StyledDrawer = styled(Drawer)({
  "& .MuiDrawer-paper": {
    width: "100%",
    maxWidth: "600px",
    overflow: "hidden",
  },
});

export const StyledCheckboxGrid = styled(Stack)({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  alignItems: "center",
  gap: "5px",
});

export const StyledTimeline = styled(Stack)({
  gap: 0,
  position: "relative",
  paddingLeft: 20,
  "&::before": {
    content: '""',
    position: "absolute",
    left: 7,
    top: 8,
    bottom: 8,
    width: 2,
    borderRadius: 1,
    backgroundColor: "rgba(0,0,0,0.08)",
  },
});

export const StyledTimelineItem = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  gap: 10,
  padding: "8px 0",
  position: "relative",
  "&::before": {
    content: '""',
    position: "absolute",
    left: -17,
    top: 14,
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: theme.palette.hubColors.mainFocus,
  },
}));
